module.exports = __webpack_public_path__ + "img/services.241529f6.jpg";